import { baseApiUrl } from 'mapbox-gl';

export const environment = {
  mapbox: {
    accessToken:
      'pk.eyJ1Ijoidml2ZWttaXNocmEtY3BsdXMiLCJhIjoiY2w2dnM1dTg3MDFlZzNicDdmdWxvOGNwOSJ9.8laNCJkgJbgRoh7bVa9xKg',
  },
  baseURL: 'https://dasasplace.com',
  FILE_STREAM_URL: 'https://dasasplace.com/BackendDASA-1.0.0/api/images/streamer/',
  CMS_API_URL: "https://dasasplace.com/dasa/v1/api/customer/requestHandler",
  dasa_order_url: "https://dasasplace.com/dasa/report/kot.jsp?orderId=",
  BILL_REPORT_URL: "https://dasasplace.com/dasa/report/bill.jsp?orderId=",
  API_REPORT_URL: "https://dasasplace.com/dasa/v1/api/reports/requestHandler",
  WEB_SOCKET_URL: "wss://dasasplace.com/dasa/websocket",
  NEW_WEB_SOCKET_URL: "wss://www.dasasplace.com/BackendDASA-1.0.0/ws",
  NEW_BACKEND_URL: "https://dasasplace.com/BackendDASA-1.0.0/",
  // NEW_BACKEND_URL: "http://localhost:9000/",
  // Public customer-app base URL. Used by the QR Table Ordering "Print QR"
  // flow to build the landing URL customers scan into. Must NOT include a
  // trailing slash. The Angular customer app is served at /customer/ on
  // the same host as the backend, hence the path suffix here.
  CUSTOMER_URL: "https://dasasplace.com/customer",
  squareApplicationId: 'sandbox-sq0idb-jItZWLgr7Af5FR2pDppm6A',
  squareLocationId: 'LVKQTZ17XRNM5',
  PAYPAL_USERNAME: '',
  PAYPAL_PASSWORD: '',
  BROWSERSTACK_USERNAME: '',
  BROWSERSTACK_ACCESS_KEY: '',
  braintreeKey: 'sandbox_2493bdxv_d6f5fgqwpc93whsv',
  production: false,
  STRIPE_SECRET_KEY:
    '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',
  STRIPE_PUBLISHATION_KEY:
    'pk_test_51QeII5Q1MjofPWgI5z0hyqIcRIoaeFitmm0uikiZVjgw2TFC0Cz5soa68YthptA8UsP9eXpY6HL1BQjuug42SQZR00vehyFyRn',
  WHAPI_URL: 'https://gate.whapi.cloud/',
  WHAPI_BEARER_TOKEN: 'jnFKdUxHGXnqeTgSdkeShBIE0Ym4zELm',
  SUPPORT_WEB_SOCKET_URL: 'wss://www.dasasplace.com/BackendDASA-1.0.0/ws',
};
